import * as React from 'react';
import { Button, ButtonProps } from './Button';
import { Loading } from '../Loading/Loading';
export interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void> | void;
}

/**
 * LoadingButton component that extends the Button component with loading state functionality
 */
const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(({
  children,
  onClick,
  disabled,
  className,
  ...props
}, ref) => {
  const [internalIsLoading, setInternalIsLoading] = React.useState(false);
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (internalIsLoading || !onClick) return;
    try {
      setInternalIsLoading(true);
      await onClick(event);
    } finally {
      setInternalIsLoading(false);
    }
  };
  return <Button ref={ref} onClick={handleClick} disabled={internalIsLoading || disabled} className={className} {...props}>
        {internalIsLoading ? <Loading className='absolute p-2' /> : null}
        {children}
      </Button>;
});
export default LoadingButton;